import { AppFunctionGroup } from './app-function-group';
import { AppFunction } from './app-function';
import { SecurityGroup } from "./security-group";
import { SecurityTargetElement } from './security-target-element';

export interface User {
	id: number;
	username: string;
	password: string;
	name: string;
	lastLogin: string;
	email: string;
	status: number;
	securityGroups: Array<SecurityGroup>;
	appFunctions: Array<AppFunction>;
	displayStatus: string;
	invitation_count: number;
	last_invitation_date: string;
	invitation_status: number;
	invitation_token: string;
	security_elements: Array<any>;
	dashboard_settings: string;
	agencyId: number;

	securityTargetElements: SecurityTargetElement[];
}

export class User {

	constructor(withZero: boolean = false) {

		if (withZero === true) {
			this.id = 0;
		}
		else {
			this.id = null;
		}
		this.username = '';
		this.password = null;
		this.name = '';
		this.status = 1;
	}

	initializeLongUser(): User {
		this.id = -1;
		this.username = '';
		this.password = '';
		this.name = '';
		this.email = 'a@b.com';
		this.status = 1;
		this.securityGroups = [];
		this.displayStatus = '';
		this.lastLogin = '';
		this.invitation_count = 0;
		this.last_invitation_date = '';
		this.invitation_status = 0;
		this.invitation_token = '';
		this.dashboard_settings = '';
		this.security_elements = [];
		this.agencyId = 0;

		return this;
	}

}
